module.exports = __webpack_public_path__ + "assets/images/c965cfc3473eab4c4b6e8d496690975c.png";